import { useLang } from "../context/LanguageContext";

export default function PartnerMarquee() {
  const { t } = useLang();
  const items = t.home.marquee;
  const row = [...items, ...items];

  return (
    <div className="marquee relative border-y border-sovereign/10 bg-obsidian/80 py-5 overflow-hidden" data-testid="partner-marquee" aria-label="Technology domains">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0" aria-hidden={i >= items.length}>
            <span className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-slate-400 px-6 whitespace-nowrap">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-sovereign/50" aria-hidden="true" />
          </span>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent pointer-events-none" aria-hidden="true" />
    </div>
  );
}
